/**
 * Web · 开弹窗前选图策略
 *
 * 与 iOS 相同使用 detached input + focus fallback（桌面浏览器取消检测足够）。
 * 上传 auth 由弹窗内 `resolvePortfolioUploadAuthHeaders` 处理，不在 pick 层。
 */
import type { PortfolioUploadType } from "@/src/components/PortfolioScreenshotModal/types";
import { pickPortfolioFilesWithFocusFallback } from "../shared/pickPortfolioFilesWithFocusFallback";

export async function pickPortfolioFilesOnWeb(
  uploadType: PortfolioUploadType,
): Promise<File[] | null> {
  return pickPortfolioFilesWithFocusFallback(uploadType);
}
